import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalController } from '@ionic/angular';
import { Subscription, finalize, take } from 'rxjs';

// Serviços
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { LoadingService } from '../../loading/loading.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';

// Componentes/Modais
import { ModalComponent } from '../../modal/modal.component';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { LinkUserModalComponent } from './link-user-modal/link-user-modal.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-entities-list',
  templateUrl: './entities-list.component.html',
  styleUrls: ['./entities-list.component.scss'],
})
export class EntitiesListComponent implements OnInit, OnDestroy {
  // Configurações da Tabela
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  
  columnConfig = [
    { columnDef: 'perfil', header: 'Tipo de entidade', property: 'tipoEntidade.nome' },
    { columnDef: 'razaoSocial', header: 'Razão Social', property: 'razaoSocial', customTd: true },
    { columnDef: 'cnpj', header: 'CNPJ', property: 'cnpj', customTd: true },
    { columnDef: 'telefone', header: 'Telefone', property: 'foneContatoEntidade', customTd: true },
    { columnDef: 'statusDefault', header: 'Status', property: 'status', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];
  
  // Filtro de Status (Chips rápidos)
  arrayStatus: any = [
    { label: "Ativo", property: "true", selected: false },
    { label: "Inativo", property: "false", selected: false },
  ];

  // Controle de Paginação e Ordenação
  pageSize: number = 10;
  pageIndex: number = 0;
  totalElements: number = 0;
  totalPages: number = 1;
  sortState: any = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };

  // Filtros Ativos
  filterTextValue: string = '';
  statusFilter: string = '';
  filterData: any; // Dados vindos do Modal de Filtros

  // Permissões e UI
  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  currentRoute: string = '';
  disabledTooltipMessage: string = 'Ação não permitida';
  criterios: any = [];
  criteriosLabels!: { [key: string]: string; };
  private subscriptions: Subscription[] = [];
  form!: FormGroup;
  constructor(
    private router: Router,
    private entitieService: EntitiesService,
    private loadingService: LoadingService,
    public toastService: ToastService,
    public dialog: MatDialog,
    private modalCtrl: ModalController,
    private authService: AuthService,
    private userService: UserService,
     private fb: FormBuilder,
  ) {
    this.currentRoute = this.router.url;
  }

  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.form = this.fb.group({
      cep: [''],
      cpfRepLegal: [''],
      nomeRepLegal: [''],
      emailEmpresa: [''],
      tipoEntidade: ['']
    });

    this.loadUserInfo();
    this.onGetEntities();
    this.buildCriteriosLabels();
  }

    private buildCriteriosLabels() {
    this.criteriosLabels = {
      cep: 'CEP',
      cpfRepLegal: 'CPF do representante',
      nomeRepLegal: 'Nome do representante',
      emailEmpresa: 'Email da empresa',
      tipoEntidade: 'Tipo de Entidade',
    };
  }
  /**
   * Busca principal de dados
   */
  onGetEntities(pageIndex: number = 0) {
    this.loadingService.showLoading();
    
    // Extração segura dos filtros avançados
    const f = this.filterData?.value || {};

    this.entitieService.getEntities(
      pageIndex,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
      f.tipoEntidade || '',
      this.filterTextValue, // Busca por Razão Social
      this.filterTextValue, // Busca por Nome Fantasia
      this.statusFilter,
      f.cnpj || '',
      (f.cep || '').replace(/[.\-]/g, ''),
      (f.cpfRepLegal || '').replace(/[.\-]/g, ''),
      f.nomeRepLegal || '',
      f.emailEmpresa || ''
    )
    .pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    )
    .subscribe({
      next: (res: any) => {
        this.dataSource.data = res.content;
        this.pageSize = res.pageSize;
        this.totalPages = res.totalPages;
        this.totalElements = res.totalElements;
        this.pageIndex = res.pageNumber;
      },
      error: (erro: any) => {
        const msg = erro?.error?.message || 'Erro ao carregar entidades';
        this.toastService.showError(msg);
      }
    });
  }

  // === EVENTOS DA TABELA (OUTPUTS) ===

  onSortChange(sortProperty: string): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection = this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.onGetEntities(0);
  }

  pageChangeEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.onGetEntities(event.pageIndex);
  }

  applyFilter(filterValue: string) {
    this.filterTextValue = filterValue;
    this.onGetEntities(0);
  }

  filterStatusChanged(event: any) {
    // Se o evento vier do chip de status do table-default
    this.statusFilter = event[0]?.property || '';
    this.onGetEntities(0);
  }

  // === MODAIS E NAVEGAÇÃO ===

  openModalFilters() {
        let props;
    if(this.filterData ){
      props = this.filterData;
    }else{
      props = this.generatePropsFromForm(this.form);
    }
  
    const data = {
      type: 'entitie',
      propsEntities: props
    };
  
    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['filter-panel'],
      data,
    });
  
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.filterData = res;
        this.criterios = this.getCriterios(res);
        this.onGetEntities(0);
      }
    });
  }

  create() {
    this.router.navigate(['/criar-entidade']);
  }

  redirectToEditPage(entitieId: any) {
    this.router.navigate([`/entidade/${entitieId}/editar`]);
  }

  // === AÇÕES DE STATUS (ATIVAR/INATIVAR/EXCLUIR) ===

  openDeleteDialog(id: any): void {
    this.openConfirmDialog('Excluir', 'Você tem certeza que deseja excluir esta Entidade?', () => {
      this.entitieService.deleteEntity(id).subscribe({
        next: (resp: any) => { this.toastService.showSuccess(resp.message); this.onGetEntities(); },
        error: (err) => this.toastService.showError(err?.error?.message)
      });
    });
  }

  openInactivateDialog(id: any): void {
    this.openConfirmDialog('Inativar', 'Você tem certeza que deseja inativar esta Entidade?', () => {
      this.entitieService.inactivate(id).subscribe({
        next: (resp: any) => { this.toastService.showSuccess(resp.message); this.onGetEntities(); },
        error: (err) => this.toastService.showError(err?.error?.message)
      });
    });
  }

  openActivateDialog(id: any): void {
    this.openConfirmDialog('Ativar', 'Você tem certeza que deseja ativar esta Entidade?', () => {
      this.entitieService.activate(id).subscribe({
        next: (resp: any) => { this.toastService.showSuccess(resp.message); this.onGetEntities(); },
        error: (err) => this.toastService.showError(err?.error?.message)
      });
    });
  }

  private openConfirmDialog(title: string, content: string, action: Function) {
    this.dialog.open(ModalComponent, {
      data: {
        modalTitle: title,
        modalContent: content,
        onPerformAction: action
      },
    });
  }

  // === MÉTODOS DE VINCULAÇÃO E HISTÓRICO ===

  async openLinkUserDialog(id: any) {
    const modal = await this.modalCtrl.create({
      component: LinkUserModalComponent,
      componentProps: { 
        idEntity: id, 
        data: { 
          buttonInclusaoDisabled: this.buttonInclusaoDisabled,
          buttonExclusaoDisabled: this.buttonExclusaoDisabled 
        } 
      },
      cssClass: 'modal-lg',
    });
    modal.present();
  }

  async openDialogHistoricoEntidade(entitieId: number) {
    const data = {
      type: 'entitie',
      id: entitieId,
      fieldMappings: {
        tipoEntidade: 'Tipo de Entidade',
        razaoSocial: 'Razão Social',
        cnpj: 'CNPJ',
        emailEntidade: 'E-mail',
        foneContatoEntidade: 'Fone de Contato',
        status: 'Status'
      }
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: { data: data, fieldMappings: data.fieldMappings },
    });
    modal.present();
  }

  // === CONTROLE DE ACESSO ===

  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        response.profileUser.permissaoPerfis.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }

  checkFunctionality(functionality: any) {
    const normalize = (str: string) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/gi, '').toLowerCase();
    
    if (normalize(functionality.nome) === normalize(this.currentRoute) || functionality.url === this.currentRoute) {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades?.length > 0) {
      functionality.subFuncionalidades.forEach((sub: any) => this.checkFunctionality(sub));
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach(r => {
      if (r.nome === 'Inclusão') this.buttonInclusaoDisabled = true;
      if (r.nome === 'Exclusão') this.buttonExclusaoDisabled = true;
      if (r.nome === 'Edição') this.buttonEdicaoDisabled = true;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

    // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);
  
      // Verifica se o controle tem valor e não é nulo ou vazio
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }
  
  getCriterios(data: any) {
    const criterios = [];
  
    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);
  
    for (const prop in props) {
      if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
        criterios.push(prop);
      }
    }
  
    return criterios;
  }
  criterioRemoved(event:any){


    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null
    });
    this.criterios = this.criterios.filter((c:any) => c !== event.criterio);
    this.onGetEntities(0);
  }
}